
import http from './index.ts'
import { message } from 'antd';
// 文件类型接口
export interface FileResponse {
  success: boolean
  data?: any
  message?: string
  extra?: any
}
const BASE_URL = '/file'
// 上传文件接口
export const uploadFile = async (file: File): Promise<FileResponse> => {
  if (!isValidFileType(file.name)) {
    message.error('文件类型不支持'); // 直接 UI 提示
    throw new Error('文件类型不支持');
  }

  const formData = new FormData()
  formData.append('file', file)

  return http.post(`${BASE_URL}/upload`, formData)
}
export const deleteFile = async (fileUrl: string) => {
  return http.delete(BASE_URL + `/delete?fileUrl=${fileUrl}`)
}
export const submitFiles = async (data: any): Promise<Object> => {
  return http.post('/api/admin/rag/training', data)
}


// 导出支持的文件类型
export const SUPPORTED_FILE_TYPES = [
  'jpg',
  'jpeg',
  'png',
  'webp',
  'pdf',
  'txt',
  'csv',
  'docx',
  'doc',
  'xlsx',
  'xls',
  'pptx',
  'ppt',
  'md',
]

// 验证文件类型
export const isValidFileType = (filename: string): boolean => {
  const extension = filename.split('.').pop()?.toLowerCase()
  return extension ? SUPPORTED_FILE_TYPES.includes(extension) : false
}



